import React, { useEffect } from 'react';

const PRINT_CONTENT_CLASS = 'modal-print-content-tax-invoice';
const PRINT_CSS_PATH = '/css/tax_invoice_print.css';

const TaxInvoicePrintModal = ({ open, onClose, title = 'Tax Invoice Print', children }) => {
    useEffect(() => {
        if (!open) return undefined;

        const cssHref = `${process.env.PUBLIC_URL || ''}${PRINT_CSS_PATH}`;
        const existing = document.getElementById('tax-invoice-preview-css');
        if (existing) existing.remove();

        const link = document.createElement('link');
        link.id = 'tax-invoice-preview-css';
        link.rel = 'stylesheet';
        link.href = cssHref;
        document.head.appendChild(link);

        return () => {
            document.getElementById('tax-invoice-preview-css')?.remove();
        };
    }, [open]);

    if (!open) return null;

    const detectAndPrint = (printWindow) => {
        const container = printWindow.document.getElementById('container');
        if (container) {
            // A4 at 96dpi ~ 1122px; subtract 150px top padding and ~50px margins
            const pageHeight = 1122 - 200;
            if (container.scrollHeight > pageHeight) {
                container.classList.add('multi-page');
            }
        }
        printWindow.document.close();
        setTimeout(() => {
            printWindow.print();
            printWindow.close();
        }, 100);
    };

    const handlePrint = () => {
        const printWindow = window.open('', '_blank');
        if (!printWindow) return;

        const baseUrl = window.location.origin + (process.env.PUBLIC_URL || '');
        const cssHref = `${baseUrl}${PRINT_CSS_PATH}`;

        const doPrint = () => {
            const modalContent = document.querySelector(`.${PRINT_CONTENT_CLASS}`);
            if (modalContent) {
                const printContent = modalContent.innerHTML;
                const target = printWindow.document.getElementById('print-content');
                if (target) target.innerHTML = printContent;
            }
            detectAndPrint(printWindow);
        };

        printWindow.document.write(`
            <html>
                <head>
                    <title>${title}</title>
                    <link rel="stylesheet" href="${cssHref}" id="print-css-link" />
                    <style>
                        html, body, #print-content, #container {
                            font-family: sans-serif !important;
                        }
                        @media print {
                            html, body { margin: 0 !important; padding: 0 !important; }
                            #print-content { padding-top: 150px !important; }
                            #container { margin: 0 auto !important; padding-top: 0 !important; }
                            #sums { padding-top: 200px !important; }
                        }
                    </style>
                </head>
                <body>
                    <div id="print-content"></div>
                </body>
            </html>
        `);

        const linkEl = printWindow.document.getElementById('print-css-link');
        if (linkEl) {
            const fallback = setTimeout(doPrint, 3000);
            const done = () => { clearTimeout(fallback); doPrint(); };
            linkEl.onload = done;
            linkEl.onerror = done;
            if (linkEl.sheet) done();
        } else {
            doPrint();
        }
    };

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }}>
            <div style={{
                backgroundColor: 'white',
                width: '90%',
                height: '90%',
                borderRadius: '8px',
                position: 'relative',
                overflow: 'hidden'
            }}>
                <div style={{
                    padding: '15px',
                    borderBottom: '1px solid #ddd',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}>
                    <h5 style={{ margin: 0 }}>Print Preview</h5>
                    <div>
                        <button className="btn btn-primary btn-sm me-2" onClick={handlePrint}>
                            <i className="fas fa-print me-1"></i>
                            Print
                        </button>
                        <button className="btn btn-secondary btn-sm" onClick={onClose}>
                            <i className="fas fa-times me-1"></i>
                            Close
                        </button>
                    </div>
                </div>
                <div
                    style={{
                        height: 'calc(100% - 70px)',
                        overflow: 'auto',
                        padding: '20px',
                        fontFamily: 'sans-serif',
                    }}
                    className={PRINT_CONTENT_CLASS}
                >
                    {children}
                </div>
            </div>
        </div>
    );
};

export default TaxInvoicePrintModal;